<app-attendee-chips-filter
  class="sport-filter"
  [buttonText]="filterLabel"
  [dialogTitle]="'attendee.filters.date.modal.title' | translate"
  [hasSelectedFilters]="this.dateRange"
  (updateChipsFilter)="onSubmit()"
  (resetChipsFilter)="clear()"
  [isValidButtonDisabled]="!isFormValid"
>
  <form [formGroup]="dateFilterForm" (ngSubmit)="onSubmit()" modal-content>
    <app-form-input-group
      class="block mb-3"
      [label]="'attendee.filters.date.from.label' | translate"
      [errors]="from?.touched && from?.errors"
      errorKey="from"
    >
      <app-form-input
        #content
        formControlName="from"
        type="date"
        [min]="fromMinDate"
        [placeholder]="'attendee.filters.date.from.placeholder' | translate"
        [required]="true"
      ></app-form-input>
    </app-form-input-group>

    <app-form-input-group
      class="block mb-3"
      [label]="'attendee.filters.date.to.label' | translate"
      [errors]="to?.touched && to?.errors"
      errorKey="to"
    >
      <app-form-input
        #content
        formControlName="to"
        type="date"
        [min]="toMinDate"
        [placeholder]="'attendee.filters.date.to.placeholder' | translate"
      ></app-form-input>
    </app-form-input-group>
  </form>
</app-attendee-chips-filter>
